import { createFileRoute } from "@tanstack/react-router"

import { OberflaechePage } from "@/components/admin/auswertung/oberflaeche-page"

export const Route = createFileRoute("/_app/admin/oberflaeche")({
  component: OberflaechePage,
})
